const AUTOCAPTURE_BLOCKED_PREFIXES = [
  "/admin",
  "/app/assistant",
  "/app/asistent",
  "/app/inbox",
  "/app/session",
] as const;

const REPLAY_BLOCKED_PREFIXES = [
  "/admin",
  "/asistent",
  "/app",
  "/auth/error",
  "/gift-card/pay",
  "/partner-invitation",
  "/redeem",
  "/saglasnost",
  "/testovi",
  "/verify-request",
  "/video-call-test",
] as const;

const SURVEY_ALLOWED_PREFIXES = [
  "/",
  "/app/login",
  "/app/onboarding/terapeut",
  "/gift-card",
  "/join-org",
  "/partneri",
  "/slobodni-termini",
  "/terapeuti",
  "/testovi",
  "/upitnik",
] as const;

function matchesPrefix(pathname: string, prefix: string): boolean {
  if (prefix === "/") {
    return pathname === "/";
  }

  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

function escapeRegex(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function getPostHogPageCategory(pathname: string): string {
  if (matchesPrefix(pathname, "/admin")) {
    return "admin";
  }

  if (matchesPrefix(pathname, "/app")) {
    return "app";
  }

  if (matchesPrefix(pathname, "/terapeuti")) {
    return "therapist_marketplace";
  }

  if (
    matchesPrefix(pathname, "/slobodni-termini") ||
    matchesPrefix(pathname, "/gift-card") ||
    matchesPrefix(pathname, "/partneri")
  ) {
    return "conversion";
  }

  if (
    matchesPrefix(pathname, "/testovi") ||
    matchesPrefix(pathname, "/upitnik")
  ) {
    return "assessment";
  }

  return "marketing";
}

export function isPostHogAutocaptureBlockedPath(pathname: string): boolean {
  return AUTOCAPTURE_BLOCKED_PREFIXES.some((prefix) =>
    matchesPrefix(pathname, prefix),
  );
}

export function getPostHogAutocaptureUrlAllowlist(): RegExp[] {
  const blockedPrefixesPattern = AUTOCAPTURE_BLOCKED_PREFIXES.map((prefix) =>
    escapeRegex(prefix.slice(1)),
  ).join("|");

  // Allow autocapture everywhere except explicitly blocked sensitive paths.
  return [
    new RegExp(
      `^https?:\\/\\/[^/]+\\/(?!(?:${blockedPrefixesPattern})(?:\\/|$)).*`,
    ),
  ];
}

export function isPostHogReplayBlockedPath(pathname: string): boolean {
  return REPLAY_BLOCKED_PREFIXES.some((prefix) =>
    matchesPrefix(pathname, prefix),
  );
}

export function shouldAutoDisplayPostHogSurvey(pathname: string): boolean {
  return SURVEY_ALLOWED_PREFIXES.some((prefix) =>
    matchesPrefix(pathname, prefix),
  );
}
